import { c as _c } from "react/compiler-runtime";
import { HandleSearchSubmitType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { VillaCityDataType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { daysBetweenDates } from "@website/utils/date-format";
import { useState } from "react";
const getDestinationLatitude = (destinationItem: any) => (Array.isArray(destinationItem?.location) ? destinationItem.location[0] : destinationItem?.location?.latitude) ?? destinationItem?.location?.lat ?? destinationItem?.lat;
const getDestinationLongitude = (destinationItem: any) => (Array.isArray(destinationItem?.location) ? destinationItem.location[1] : destinationItem?.location?.longitude) ?? destinationItem?.location?.lon ?? destinationItem?.long ?? destinationItem?.lng;
export const useSubmit = (selectedDestinationItem, date, passengerNumber, addToHistory, submitValidationCheck, handleSearchSubmit, initialDestinationItem) => {
  const $ = _c(11);
  const [submitLoading, setSubmitLoading] = useState(false);
  let t0;
  if ($[0] !== addToHistory || $[1] !== date || $[2] !== handleSearchSubmit || $[3] !== initialDestinationItem || $[4] !== passengerNumber || $[5] !== selectedDestinationItem || $[6] !== submitValidationCheck) {
    t0 = async () => {
      setSubmitLoading(true);
      if (submitValidationCheck()) {
        const startDate = date[0]?.dateTime;
        const endDate = date[1]?.dateTime;
        const hasSelectedDestination = Boolean(selectedDestinationItem);
        const destinationItem = selectedDestinationItem || initialDestinationItem;
        if (destinationItem) {
          addToHistory(destinationItem, startDate, endDate, passengerNumber);
          await handleSearchSubmit?.(destinationItem.url, startDate, endDate, `${passengerNumber.adult}`, `${passengerNumber.child}`, `${passengerNumber.room}`, destinationItem.type, destinationItem?.id, destinationItem.title, getDestinationLatitude(destinationItem), getDestinationLongitude(destinationItem), hasSelectedDestination);
          const trackingPayload = {
            stay_duration_days: daysBetweenDates(startDate, endDate)
          };
          addEventToTracking(USER_TRACKING_EVENTS.DATE_SELECTED, {
            product: "villa",
            ...trackingPayload
          });
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } else {
        setSubmitLoading(false);
      }
    };
    $[0] = addToHistory;
    $[1] = date;
    $[2] = handleSearchSubmit;
    $[3] = initialDestinationItem;
    $[4] = passengerNumber;
    $[5] = selectedDestinationItem;
    $[6] = submitValidationCheck;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const onSubmitClick = t0;
  let t1;
  if ($[8] !== onSubmitClick || $[9] !== submitLoading) {
    t1 = {
      onSubmitClick,
      submitLoading
    };
    $[8] = onSubmitClick;
    $[9] = submitLoading;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};